import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class MapSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'map.control');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            this.fontFamilyField('font.family', ['main', 'content']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontColorComboField('font.color', ['main', 'content']),

            this.backgroundColorField('background.color', ['content', 'main']),
            this.backgroundColorField('secondary.background.color', ['map.control', 'content']),
            this.backgroundColorField('hover.background.color', ['map.control', 'content'], this.preset('hover-background-color', 'main')),

            this.borderColorField('border.color', ['main', 'content']),
            this.sizeNumberField('border.width', 'px'),
            this.sizeNumberField('border.radius', 'px'),

        ];
    }

}
